import network_constants from "../utilities/network_constants";
import AsyncStorage from "@react-native-async-storage/async-storage";

export const fetchOrganizationData = async (userId) => {
  const url = `${network_constants.organization}?AD_User_ID=${userId}`;
  console.log(`Request URL for Organization: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();

    return data;
  } catch (error) {
    console.error("Error fetching Organization data:", error);
    throw error;
  }
};

export const fetchLineMasterData = async (orgId) => {
  const url = `${network_constants.lineMaster}`;
  const whereCondition = `_where=organization.id in(select e.id from Organization e where e.id='${orgId}')`;
  const requestUrl = `${url}?${whereCondition}`;

  console.log(`Request URL for Line Master: ${requestUrl}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    console.log("Fetched Line Master data:", data);

    return data;
  } catch (error) {
    console.error("Error fetching Line Master data:", error);
    throw error;
  }
};

export const fetchWarehouseData = async (warehouseId) => {
  const url = `${network_constants.warehouseData}`;
  const whereCondition = `_where=id in(select e.id from Warehouse e where e.id='${warehouseId}')`;
  const requestUrl = `${url}?${whereCondition}`;

  console.log(`Request URL for Warehouse Data: ${requestUrl}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    console.log("Fetched Warehouse Data:", data);

    return data;
  } catch (error) {
    console.error("Error fetching Warehouse Data:", error);
    throw error;
  }
};

export const getClientIP = async () => {
  try {
    const response = await fetch("https://api.ipify.org?format=json");
    const data = await response.json();
    console.log(data);
    return data.ip;
  } catch (error) {
    console.error("Error fetching client IP:", error);
    return null;
  }
};

export const loginService = async ({ User, pass }) => {
  const url = `${network_constants.Login}`;
  console.log(`Request URL for Login: ${url}`);
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${User}:${pass}`),
        "Content-Type": "application/json",
      },
    });
    console.log("Response Headers:", [...response.headers]);
    console.log("Raw response:", response);

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const text = await response.text();
    console.log("Response text:", text);

    if (!text) {
      throw new Error("Empty response from server");
    }

    return JSON.parse(text);
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};

export const fetchDguRemoteIP = async (userId) => {
  const url = `${network_constants.DguRemoteIP}`;
  const whereCondition = `_where=user in(select e.id from ADUser e where e.id='${userId}')`;
  const requestUrl = `${url}?${whereCondition}`;
  console.log(`Fetching DGU Remote IP from: ${requestUrl}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("DGU Remote IP:", data.response.data);

    return data;
  } catch (error) {
    console.error("Error fetching DGU Remote IP:", error);
    return null;
  }
};

export const fetchADUser = async (userId) => {
  const url = `${network_constants.fetchADUser}`;
  const whereCondition = `_where=id in(select e.id from ADUser e where e.id='${userId}')`;
  const requestUrl = `${url}?${whereCondition}`;
  console.log(`Fetching ADUser from: ${requestUrl}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("ADUser Details:", data.response.data);

    return data;
  } catch (error) {
    console.error("Error fetching ADUser:", error);
    return null;
  }
};

export const fetchSeasonData = async () => {
  const url = `${network_constants.season}`;
  console.log(`Request URL for Season: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    console.log("Fetched Season data:", data);

    return data;
  } catch (error) {
    console.error("Error fetching Season data:", error);
    throw error;
  }
};

export const fetchDispatchData = async (organization, lineMaster) => {
  const url = `${network_constants.realTimeLineActivity}?AD_Org_ID=${organization}&DGM_Newlinemaster_ID=${lineMaster}`;
  console.log(`Request URL: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("Fetched data:", data);

    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const realTimeLineActivityLine = async (
  organization,
  lineMaster,
  ProcesstypeId
) => {
  const url = `${network_constants.realTimeLineActivityLine}?AD_Org_ID=${organization}&DGM_Newlinemaster_ID=${lineMaster}&DGW_Processtype_ID=${ProcesstypeId}`;
  console.log(`Request URL: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("realTimeLineActivityLine Fetched data:", data);

    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const realTimeLineActivityNonSeed = async (
  organization,
  lineMaster,
  ProcesstypeId
) => {
  const url = `${network_constants.realTimeLineActivityNonSeed}?AD_Org_ID=${organization}&DGM_Newlinemaster_ID=${lineMaster}&DGW_Processtype_ID=${ProcesstypeId}`;
  console.log(`Request URL: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("realTimeLineActivityNonSeed Fetched data:", data);

    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchRealTimeWarehouseActivityData = async (organization) => {
  const url = `${network_constants.realTimeWarehouseActivity}?AD_Org_ID=${organization}`;
  console.log(`Request URL: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("Fetched Real-Time Warehouse Activity data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching Real-Time Warehouse Activity data:", error);
    throw error;
  }
};

export const fetchRealTimeWarehouseLineData = async (
  organization,
  dateFrom,
  dateTo
) => {
  const url = `${network_constants.realTimeWarehouseLine}?AD_Org_ID=${organization}&DateFrom=${dateFrom}&DateTo=${dateTo}`;
  console.log(`Request URL: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("Fetched Real-Time Warehouse Line data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching Real-Time Warehouse Line data:", error);
    throw error;
  }
};

export const fetchRealTimeWarehouseCountData = async (warehouseId) => {
  const url = `${network_constants.realTimeWarehouseCount}?M_Warehouse_ID=${warehouseId}`;
  console.log(`Request URL: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("Fetched Real-Time Warehouse Count data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching Real-Time Warehouse Count data:", error);
    throw error;
  }
};

export const fetchDrierStatusReport = async (
  organization,
  season,
  drierType
) => {
  const url = `${network_constants.drierStatusReport}?AD_Org_ID=${organization}&DGM_Season_ID=${season}&Typeofdryer=${drierType}`;
  console.log(`Request URL main: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("Fetched Drier Status Report data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching Drier Status Report data:", error);
    throw error;
  }
};

export const fetchDrierStatusReportEven = async (
  organization,
  season,
  drierType
) => {
  const url = `${network_constants.drierStatusReportEven}?AD_Org_ID=${organization}&DGM_Season_ID=${season}&Typeofdryer=${drierType}`;
  console.log(`Request URL even: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("Fetched Even Drier Status Report data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching Even Drier Status Report data:", error);
    throw error;
  }
};

export const fetchDrierStatusReportOdd = async (
  organization,
  season,
  drierType
) => {
  const url = `${network_constants.drierStatusReportOdd}?AD_Org_ID=${organization}&DGM_Season_ID=${season}&Typeofdryer=${drierType}`;
  console.log(`Request URL odd: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    console.log("Fetched Odd Drier Status Report data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching Odd Drier Status Report data:", error);
    throw error;
  }
};

export const fetchDryingTransactionTemp = async (
  organization,
  season
) => {
  const whereClause = `organization='${organization}' and dGMSeason='${season}'`;

  const url = `${network_constants.DryingTransactionTemp
    }?_where=${encodeURIComponent(whereClause)}
&_orderBy=${encodeURIComponent("updated desc")}
&_startRow=0
&_endRow=1
&_selectedProperties=upfronttemp,updpinwc,uphumidityrh,upreartemp,lpfronttemp,lpdpinwc,lphumidityrh,lpreartemp`;

  console.log("Request URL drying:", url);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Fetched DryingTransactionTemp data:", data);
    return data.response.data;

  } catch (error) {
    console.error("Error fetching DryingTransactionTemp data:", error);
    throw error;
  }
};

export const fetchWarehouseStatusData = async (
  organization,
  dateFrom,
  dateTo
) => {
  const url = `${network_constants.warehouseStatus}?AD_Org_ID=${organization}&DateFrom=${dateFrom}&DateTo=${dateTo}`;
  console.log(`Request URL: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Fetched Warehouse Status data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching Warehouse Status data:", error);
    throw error;
  }
};

export const fetchWarehouseStatusLineSeedData = async (warehouseId) => {
  const url = `${network_constants.warehouseStatusLineSeed}?M_Warehouse_ID=${warehouseId}`;
  console.log(`Request URL: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Fetched Warehouse Status Line Data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching Warehouse Status Line Data:", error);
    throw error;
  }
};

export const fetchWarehouseStatusLineNonSeedData = async (warehouseId) => {
  const url = `${network_constants.warehouseStatusLineNonSeed}?M_Warehouse_ID=${warehouseId}`;
  console.log(`Request URL: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Fetched Warehouse Status Line Data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching Warehouse Status Line Data:", error);
    throw error;
  }
};

export const fetchScreenData = async (organization) => {
  const url = `${network_constants.screenname}`;
  const whereCondition = `_where=organization.id in(select e.id from Organization e where e.id='${organization}')`;
  const requestUrl = `${url}?${whereCondition}`;
  console.log(`Request URL: ${requestUrl}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Fetched Screen Data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching screen data:", error);
    throw error;
  }
};

export const fetchScreenReportsData = async (screenid) => {
  const url = `${network_constants.screenReport}?DGM_Screenname_ID=${screenid}`;
  console.log(`Request URL: ${url}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Fetched Screen Data:", data);
    return data;
  } catch (error) {
    console.error("Error fetching screen data:", error);
    throw error;
  }
};

export const fetchDynamicData = async (apiUrl) => {
  const fullUrl = `${apiUrl}`;

  console.log(`Requesting API: ${fullUrl}`);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(fullUrl, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    console.log("Fetched Data:", data);

    return data;
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};

export const fetchTimeline = async (
  fromDate, 
  toDate, 
  organization = '', 
  season = '', 
  typeOfDryer = '', 
  binNo = '', 
  cycleNo = '', 
  orgId = '', 
  warehouseId = '', 
  basicauth = ""  
) => {
  try {
    if (!fromDate || !toDate) {
      console.warn("From date or to date is missing");
      return [];
    }

    const start = `${fromDate}`;
    const end = `${toDate}`;

    let whereCondition = `datetime>='${start}' and datetime<='${end}'`;
    const encodedWhere = encodeURIComponent(whereCondition);
 
    let url = `${network_constants.TimeLineReport}?_where=${encodedWhere}`;
 
    if (warehouseId && warehouseId !== '') {
      url += `&warehouse='${warehouseId}'`;
      console.log("Added warehouse to URL:", warehouseId);
    } else {
      console.warn("warehouseId is empty or missing");
    }
    
    if (orgId && orgId !== '') {
      url += `&organization=${orgId}`;
      console.log("Added organization to URL:", orgId);
    } else {
      console.warn("orgId is empty or missing");
    }
    url += `&_selectedProperties=upfronttemp,datetime,orgId`;
    
    console.log("Final Request URL:", url);

   
    let auth = basicauth;

    
    if (!auth) {
      auth = sessionStorage.getItem("basicauth");
      console.log("📦 Using basicauth from sessionStorage");
    }

    if (!auth) {
      throw new Error("No BasicAuth found. Please provide basicauth.");
    }

    console.log("🔑 Using basicauth for authentication");

    
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: ` ${auth}`,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const res = await response.json();
    const data = res.response?.data || [];
    const sortedData = data.sort((a, b) => (a.id || 0) - (b.id || 0));

    console.log("✅ Fetched:", sortedData.length, "records");
    return sortedData;

  } catch (error) {
    console.error("❌ Error in fetchTimeline:", error);
    throw error;
  }
};
export const fetchOrganization = async (organization) => {
  const whereCondition = `_where=id='${organization}'&_selectedProperties=name`;
  const requestUrl = `${network_constants.Organization}?${whereCondition}`;

  console.log("Request URL:", requestUrl);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();

    console.log("Fetched Organization Data:", data);

    return data;
  } catch (error) {
    console.error("Error fetching organization data:", error);
    throw error;
  }
};

export const fetchOrganizations = async (userId = "100") => {
  const whereCondition = `_where=${encodeURIComponent(`
    id in (
      select ro.organization.id from ADRoleOrganization ro
      where ro.role.id in (
        select ur.role.id
        from ADUserRoles ur
        where ur.userContact.id='${userId}'
      )
    )
  `)}&_selectedProperties=id,name,isActive`;

  const requestUrl = `${network_constants.Organization}?${whereCondition}`;

  console.log("Organization URL:", requestUrl);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    return data.response?.data || [];
  } catch (error) {
    console.error("Organization Error:", error);
    throw error;
  }
};

export const fetchSeasons = async (userId = "100") => {
  const requestUrl = `${network_constants.Season}?_selectedProperties=id,seasonName,name,startDate,endDate,isActive`;
  console.log("Season URL (Modified - Fetching All):", requestUrl);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("No username or password found");
    }

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("Season API Response:", data);
    
    const seasons = data.response?.data || [];
    console.log(`✅ Found ${seasons.length} seasons in database`);
    
    if (seasons.length > 0) {
      console.log("First season:", seasons[0]);
    }
    
    return seasons;
  } catch (error) {
    console.error("Season Error:", error);
    throw error;
  }
};

export const fetchBinMasters = async (userId = "100") => {
  const whereCondition = `_where=${encodeURIComponent(`
    organization.id in (
      select ro.organization.id from ADRoleOrganization ro
      where ro.role.id in (
        select ur.role.id
        from ADUserRoles ur
        where ur.userContact.id='${userId}'
      )
    )
  `)}&_selectedProperties=id,binno,isActive,organizationId`;

  const requestUrl = `${network_constants.DGM_Binmaster}?${whereCondition}`;

  console.log("BinMaster URL:", requestUrl);

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    return data.response?.data || [];
  } catch (error) {
    console.error("BinMaster Error:", error);
    throw error;
  }
};

export const fetchBinBatch = async (organizationId, seasonId, binNo, cycleNo) => {
  console.log("=== fetchBinBatch called with ===");
  console.log("organizationId:", organizationId);
  console.log("seasonId:", seasonId);
  console.log("binNo (should be GUID):", binNo);
  console.log("cycleNo:", cycleNo);
  
  const whereCondition = `_where=${encodeURIComponent(
    `organizationId='${organizationId}' and seasonId='${seasonId}' and binNo='${binNo}' and cycleno='${cycleNo}'`
  )}`;
  
  const requestUrl = `${network_constants.BinBatch}?${whereCondition}&_selectedProperties=*`;

  console.log("BinBatch FULL URL:", requestUrl);
  console.log("===================================");

  try {
    const username = await AsyncStorage.getItem("username");
    const password = await AsyncStorage.getItem("password");

    if (!username || !password) {
      throw new Error("Credentials not found");
    }

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: "Basic " + btoa(`${username}:${password}`),
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log("BinBatch Response:", data);
    return data.response?.data || [];
  } catch (error) {
    console.error("BinBatch Error:", error);
    throw error;
  }
};

// Add this helper function at the top of your web_service.js file
const getBasicAuth = () => {
  // First check if basicauth is in sessionStorage
  let auth = sessionStorage.getItem("basicauth");
  if (auth) return auth;
  
  // If not, try to get from URL params
  try {
    const hash = window.location.hash;
    if (hash && hash.includes('?')) {
      const queryString = hash.split('?')[1];
      const params = new URLSearchParams(queryString);
      const basicauth = params.get('basicauth');
      if (basicauth) {
        // Decode and store for future use
        const decodedAuth = decodeURIComponent(basicauth);
        sessionStorage.setItem("basicauth", decodedAuth);
        return decodedAuth;
      }
    }
  } catch (error) {
    console.error("Error extracting basicauth from URL:", error);
  }
  
  return null;
};

// Updated fetchDrying function
export const fetchDrying = async (userId) => {
  const whereClause = `
    organization.id in (
      select ro.organization.id
      from ADRoleOrganization ro
      where ro.role.id in (
        select ur.role.id
        from ADUserRoles ur
        where ur.userContact.id = '${userId}'
      )
    )
  `;

  const requestUrl =
    `${network_constants.DRYING}?_where=${encodeURIComponent(whereClause)}` +
    `&_selectedProperties=id,organization,season,typeOfDryer,binNo,cycleno,warehouse`;

  try {
    // Get BasicAuth from helper function
    const auth = getBasicAuth();

    if (!auth) {
      throw new Error("No BasicAuth found. Please login again.");
    }

    console.log("🔑 Using BasicAuth for authentication");

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: auth,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    console.log("✅ Fetched drying data:", data?.response?.data?.length || 0, "records");
    return data?.response?.data || [];
    
  } catch (error) {
    console.error("Error fetching drying data:", error);
    throw error;
  }
};

// Updated fetchDryingLine function
export const fetchDryingLine = async (dryingId) => {
  const selectedProperties = [
    'serialNo',
    'batchNo', 
    'intakemoisture',
    'gateentrytime',
    'sowingdate',
    'harveststarttime',
    'harvestendtime',
    'dispatchtime',
    'unloadingendtime',
    'dryingstartdatetime',
    'dryingendtime',
    'shellingstarttime',
    'shellingendtime'
  ].join(',');

  const whereCondition = `_where=${encodeURIComponent(`drying.id='${dryingId}'`)}&_selectedProperties=${selectedProperties}`;
  const requestUrl = `${network_constants.DRYINGLINE}?${whereCondition}`;

  try {
    // Get BasicAuth from helper function
    const auth = getBasicAuth();

    if (!auth) {
      throw new Error("No BasicAuth found. Please login again.");
    }

    console.log("🔑 Using BasicAuth for authentication");

    const response = await fetch(requestUrl, {
      method: "GET",
      headers: {
        Authorization: auth,
        "Content-Type": "application/json",
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    const rawData = data.response?.data || [];
    console.log("✅ Fetched drying line data:", rawData.length, "records");
    
    const mappedData = rawData.map(item => ({
      id: item.id || item["@id"],
      dryingId: item.drying?.id || dryingId,
      serialNo: item.serialNo,
      batchNo: item.batchNo,
      intakemoisture: item.intakemoisture,
      gateentrytime: item.gateentrytime,
      sowingdate: item.sowingdate,
      harveststarttime: item.harveststarttime,
      harvestendtime: item.harvestendtime,
      dispatchtime: item.dispatchtime,
      unloadingendtime: item.unloadingendtime,
      dryingstartdatetime: item.dryingstartdatetime,
      dryingendtime: item.dryingendtime,
      shellingstarttime: item.shellingstarttime,
      shellingendtime: item.shellingendtime,
    }));
    
    return mappedData;
    
  } catch (error) {
    console.error("Drying Line Error:", error);
    throw error;
  }
};